import React from 'react';
import ReactDOM from 'react-dom/client';
import { StyledEngineProvider } from '@mui/material/styles';
import App from './App';
import { MenuAccessProvider } from './context/MenuAccessContext';
import { UiVersionProvider } from './context/UiVersionContext';
import './styles/main.css';

// injectFirst makes MUI/emotion inject its styles at the TOP of <head>, before our own
// CSS — so a plain `.my-class` on a MUI component reliably wins the cascade instead of
// silently losing to `.MuiTypography-*` by injection order. Fixes the whole class of
// "my CSS class on a MUI element doesn't apply" bugs (e.g. the Georgia serif page titles).
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <UiVersionProvider>
        <MenuAccessProvider>
          <App />
        </MenuAccessProvider>
      </UiVersionProvider>
    </StyledEngineProvider>
  </React.StrictMode>
);